module.exports = __webpack_public_path__ + "static/media/asthma_geneExp.93bad8f1.png";